import { Avatar, Card, Select, Spin } from 'antd';
import debounce from 'lodash/debounce';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import "./searchandselect.css";
import Meta from 'antd/lib/card/Meta';
import Initials from '../generateinitials/Initials';

const { Option } = Select;

function SearchAndSelect({ fetchOptions,readOnly, debounceTimeout = 300, ...props }) {
  const [fetching, setFetching] = useState(false);
  const [options, setOptions] = useState([]);
  const fetchRef = useRef(0);
  const [selectedItems, setSelectedItems] = useState(props.selectedValues || [])

  useEffect(() => {
    setSelectedItems(props.selectedValues);
    if(props.noDebounceSearch) setOptions(props.options);
  }, [props.selectedValues, props.noDebounceSearch])

  useEffect(() => {
    props.setValue(selectedItems)
  }, [selectedItems])

  const debounceFetcher = useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);
      fetchOptions(value).then((newOptions) => {
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return;
        }
        setOptions(newOptions);
        setFetching(false);
      });
    };
    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);

  const onSearch = (value) => {
    // this function is required so that the custom filter works on search in select field
  };

  return (
    <>
      <Select
        allowClear
        disabled={readOnly}
        labelInValue
        value={selectedItems}
        filterOption={props.noDebounceSearch ? (
          (input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        ) : false}
        onSearch={!props.noDebounceSearch ? debounceFetcher : onSearch}
        notFoundContent={fetching ? <Spin size="small" /> : null}
        {...props}
        onChange={setSelectedItems}
        className='select-and-search-container'
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
        }
      >
        {options.map(option => (
          <>
            {props.selectOptionType === "Simple" ? (
              <Option key={option.value} value={option.value}>{option.label}</Option>
            ) : (
              <Option value={option.value} label={option.label}>
                <Card className='list-items-cards selected-items-cards-container'>
                  <Meta
                    avatar={<Avatar className='card-avatar'>
                      <Initials value={`${option?.label}`} />
                    </Avatar>}
                    title={option.label}
                    description={option.misc}
                  />
                </Card>
              </Option>
            )}
          </>
        ))}
      </Select>
    </>
  );
}

export default SearchAndSelect;

/**
 * Usage:
 * 
 * <SearchAndSelect props/>
 * 
 * props include: 
 *  mode: "multiple" | "tags" | default is single selection
 *  placeholder: string
 *  fetchOptions: a function that provides dropdown options. It is a array of objects in the format [{ label: string, value: string, misc: string}]
 *  onChange: a function to set the local state value
 *  selectedValues: default values or already selected values from backend
 *  selectOptionType: "Simple" | "Info" -> Simple for single line selection option, Info for multi-line selection option
 *  setValue: callback to set your selected values to be accessible in the parent component
 * 
 * It will return an array of selected value objects => [{label: string, value: string, key: string}]
 */